"use strict";

exports.__esModule = true;
exports.disclaimerRoute = disclaimerRoute;
exports.DisclaimerSeoMetadata = exports.DisclaimerMetadata = exports.DisclaimerTitle = exports.DisclaimerPath = exports.DisclaimerSegment = void 0;

var _createRoute = require("../../route/createRoute");

var _getPath = require("../../route/getPath");

var DisclaimerSegment = "disclaimer";
exports.DisclaimerSegment = DisclaimerSegment;
var DisclaimerPath = (0, _getPath.getPath)(DisclaimerSegment);
exports.DisclaimerPath = DisclaimerPath;
var DisclaimerTitle = "Disclaimer";
exports.DisclaimerTitle = DisclaimerTitle;
var DisclaimerMetadata = {
  noindex: true,
  follow: true
};
exports.DisclaimerMetadata = DisclaimerMetadata;
var DisclaimerSeoMetadata = {
  robots: DisclaimerMetadata
};
exports.DisclaimerSeoMetadata = DisclaimerSeoMetadata;

function disclaimerRoute(rootPath) {
  var route = (0, _createRoute.createRoute)(rootPath, DisclaimerPath);
  route.noindex = DisclaimerMetadata.noindex;

  route.getData = function () {
    return {
      path: DisclaimerPath
    };
  };

  return route;
}